import React from "react";
import Image from "./Image";
import Redtext from "./Redtext";
import Title from "./Title";
import Maintext from "./Maintext";
import Button from "./Button";
import Bigtitle from "./Bigtitle";
import Header from "./Header";
import Faq from "../Main/Faq";
import Footer from "../Main/Footer";
import Files from "../Main/FilesForPayment";


const Article = ( {data} ) => {
    return(
        <div className="flex flex-col w-[95%] mx-auto max-w-[1510px] lg:gap-5 gap-6 py-5">
            {
                data.map((block) => {
                    switch (block.typeblock){
                        case 'header':
                            return <Header key={block.id} data={block.payload} />;
                        case 'image':
                            return <Image key={block.id} data={block.payload} />;
                        case 'bigtitle':
                            return <Bigtitle key={block.id} data={block.payload} />;
                        case 'title':
                            return <Title key={block.id} data={block.payload} />;
                        case 'redtext':
                            return <Redtext key={block.id} data={block.payload} />;
                        case 'maintext':
                            return <Maintext key={block.id} data={block.payload} />;
                        case 'button':
                            return <Button key={block.id} data={block.payload} />;
                    }
                })
            }
            {
                data.map((block) => {
                    switch (block.type){
                        case 'faq_block':
                            return <>
                                        <Files/>
                                        <Faq key={block.id} data={block.payload} />
                                    </>;
                        case 'footer_block':
                            return <Footer key={block.id} data={block.payload} />;
                    }
                })
            }

        </div>
    );
};

export default Article;